import React from 'react';
import BuyOnlineContainer from "../Containers/BuyOnline.container";
import BuyButtonWrapper from "./BuyButtonExtension";

const ProductPageBuyButtons = function (props) {
    const {
        isMuurikka,
        isProductPage,
        productItem,
        productOnlineResellers,
        noneFoundClass,
        labelAndIcon,
        openMiniCartAtCheckout = true
    } = props;

    if (labelAndIcon.isLoading && !isMuurikka) {
        return (
            <div className="find-reseller">
                <a className={`button product-detail__buy-button product-detail__buy-button--loading`} href="#">
                    {labelAndIcon.icon}
                    {labelAndIcon.label}
                </a>
            </div>
        );
    }
    
    return (
        <>
            {isMuurikka ? 
                <>
                    {productItem.showBuyButtonChannel && 
                        <div className="find-reseller"
                            onClick={e => {
                                e.preventDefault();

                                if (productItem.isBuyable && isProductPage) {
                                    window.showResellers(!productItem.isBuyable);
                                }
                            }}
                        >
                            <BuyButtonWrapper {...{
                                productItem,
                                isProductPage,
                                openMiniCartAtCheckout,
                                cssClass: "product-detail__buy-button muurikka-btn muurikka-btn--red",
                                isBuyOnline: !(!productOnlineResellers.length > 0 && productItem.isBuyable)
                            }} />
                        </div>
                    }
                </>
                : 
                <div className="find-reseller"
                    onClick={e => {
                        if (!productOnlineResellers.length) return;
                        e.preventDefault();
                        window.showResellers(productItem.isBuyable)
                    }}
                >
                    <BuyButtonWrapper {...{
                        productItem: productItem,
                        cssClass: "product-detail__buy-button",
                        isBuyOnline: true,
                        openMiniCartAtCheckout: false,
                        labelAndIcon,
                        noneFoundClass
                    }} />
                </div>
            }

            {(!isMuurikka || productItem.isInStock) && 
                <BuyOnlineContainer {...props}/>
            }
        </>
    );
}

export default ProductPageBuyButtons;
